<a [href]="item?.itemRef" target="_blank" (click)="clicked.emit(item)">
  <img [src]="src" />
</a>
